import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/destaques',
		component: Base,
		children: [
			{
				path: '',
				name: 'DestaquesList',
				component: List,
				meta: {
					path: '/site/destaques',
					pai: 'Site',
					title: 'Admin - Destaques',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Destaques',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'DestaquesNovo',
				component: Form,
				meta: {
					path: '/site/destaques',
					pai: 'Site',
					title: 'Admin - Destaques - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Destaques',
						class: '',
						active: false,
						url: '/site/destaques'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'DestaquesEditar',
				component: Form,
				meta: {
					path: '/site/destaques',
					pai: 'Site',
					title: 'Admin - Destaques - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Destaques',
						class: '',
						active: false,
						url: '/site/destaques'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]